import moment from 'moment'

export const toHumanReadable = (date) => {
  const formatted = moment(date).format('MMMM D, YYYY')
  return `${formatted.charAt(0)}${formatted.substr(1).toLowerCase()}`
}
